import React, { useEffect, useState } from 'react'
import {
    IconButton,
    makeStyles,
    TableCell,
    TableRow,
    Divider,
    List,
    ListItemText,
    Dialog,
    DialogTitle,
    DialogContent,
    Typography,
} from '@material-ui/core'
import {
    ErrorSheet,
    Locker,
    OrderImportedFromXLS,
} from '../pages/importSheetFile/interfaces'
import InfoIcon from '@material-ui/icons/Info'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles({
    tableRow: {
        border: 'none',
        '& td': {
            paddingTop: '10px',
            paddingBottom: '10px',
        },
    },
    errorTableRow: {
        border: 'none',
        '& td': {
            paddingTop: '10px',
            paddingBottom: '10px',
            color: '#ff0000',
        },
    },
    errorRow: {
        borderTop: '2px solid #fff',
        height: '30px',
        borderRight: 'none',
        borderLeft: 'none',
    },
    subTableContainer: {
        paddingBottom: 0,
        paddingTop: 0,
        borderBottom: '1px solid rgb(224, 224, 224)',
    },
    subTableBox: {
        margin: '30px',
        padding: '30px',
        backgroundColor: '#eeeeee',
    },
    subTable: {
        backgroundColor: '#fff',
        border: 'none',
    },
    subTableHead: {
        border: 'none',
    },
    subTableRow: {
        border: 'none',
    },
    errorMessage: {
        color: 'red',
        '& span': {
            fontSize: '13px',
        },
    },
    dialog: {
        maxWidth: '600px',
        margin: 'auto',
    },
    list: {
        '& div': {
            padding: '5px',
        },
    },
    closeBtn: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
})

const ImportSheetTable = (props: {
    rowNumber: number
    order: OrderImportedFromXLS
    allLockers: Locker[]
    importErrors?: ErrorSheet[]
    saveErrors?: ErrorSheet[]
    DoorSizeId: number
    orderCustomSecurity:boolean
}) => {
    const styles = useStyles()
    const { order, allLockers, importErrors, rowNumber, saveErrors, orderCustomSecurity } = props
    const [lockerOpen, setLockerOpen] = useState(false)
    const [shipmentOpen, setShipmentOpen] = useState(false)
    const [lockerInfo, setLockerInfo] = useState<Locker>(allLockers[0])
    const [loading, setLoading] = useState(true) // eslint-disable-line @typescript-eslint/no-unused-vars
    useEffect(() => {
        const getLockerInfo = () => {
            // @ts-ignore
            setLockerInfo(allLockers.find(x => x.id === order.LockerId))
            setLoading(false)
        }
        const setOrderError = () => {
            if (importErrors) {
                importErrors.forEach((error) => {
                    if (error.row === rowNumber + 1) {
                        if (order.Error === undefined) {
                            order.Error = [error]
                        } else {
                            order.Error.push({
                                row: error.row,
                                message: error.message,
                            })
                        }
                    }
                })
            }
        }

        if (saveErrors) {
            saveErrors.forEach((error) => {
                if (error.row === rowNumber + 1) {
                    if (order.SaveError === undefined) {
                        order.SaveError = [error]
                    } else {
                        order.SaveError.push({
                            row: error.row,
                            message: error.message,
                        })
                    }
                }
            })
        }
        setOrderError()
        getLockerInfo()
    }, [order, allLockers, importErrors, rowNumber, saveErrors])

    const isMobile: boolean = window.innerWidth < 900

    return (
        <React.Fragment>
            <TableRow
                className={order.Error || order.SaveError || order.SaveError ? styles.errorTableRow : styles.tableRow}
            >
                {order.LockerId ? (
                    <TableCell>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setLockerOpen(!lockerOpen)}
                        >
                            <InfoIcon
                                style={{ color: order.Error || order.SaveError || order.SaveError ? 'red' : '#000' }}
                            />
                        </IconButton>
                    </TableCell>
                ) : (
                    <TableCell>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setShipmentOpen(!shipmentOpen)}
                        >
                            <InfoIcon
                                style={{ color: order.Error || order.SaveError || order.SaveError ? 'red' : '#000' }}
                            />
                        </IconButton>
                    </TableCell>
                )}

                {isMobile ? (
                    <>
                        <TableCell>
                            {order.LockerId ? 'SmartLocker' : 'Domicilio'}
                        </TableCell>
                        <TableCell>
                            {order.DepositCode && order.DepositCode.length > 0
                                ? order.DepositCode
                                : order.ClientMail}
                        </TableCell>
                    </>
                ) : null}

                {!isMobile ? (
                    <>
                        <TableCell>
                            {order.LockerId ? 'SmartLocker' : 'Domicilio'}
                        </TableCell>
                        <TableCell>{order.ClientMail}</TableCell>
                        <TableCell>{order.ClientName}</TableCell>
                        <TableCell>{order.ClientPhone}</TableCell>
                        <TableCell>{order.DepositCode}</TableCell>
                    </>
                ) : null}
            </TableRow>
            <Dialog
                open={shipmentOpen}
                onClose={() => setShipmentOpen(false)}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                className={styles.dialog}
                scroll={'paper'}
                maxWidth={'sm'}
                fullWidth
            >
                <DialogTitle id="scroll-dialog-title">
                    Envío a domicilio
                    <IconButton
                        aria-label="close"
                        className={styles.closeBtn}
                        onClick={() => setShipmentOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <List
                        className={styles.list}
                        id="scroll-dialog-description"
                    >
                        {order.DepositCode !== null && order.DepositCode !== undefined ? (
                            <ListItemText
                                primary="Código de depósito:  "
                                secondary={order.DepositCode}
                                primaryTypographyProps={{ display: 'inline' }}
                                secondaryTypographyProps={{ display: 'inline' }}
                            />
                        ) : null}
                        <ListItemText
                            primary="Alias:  "
                            secondary={order.Alias ? order.Alias : '-'}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Nombre:  "
                            secondary={order.ClientName}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Mail:  "
                            secondary={order.ClientMail}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Teléfono:  "
                            secondary={order.ClientPhone}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <Divider />
                        <ListItemText
                            primary="Calle:  "
                            secondary={order.StreetName}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Número:  "
                            secondary={order.StreetNumber}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Piso:  "
                            secondary={order.Floor ? order.Floor : '-'}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Departamento:  "
                            secondary={order.Apartment ? order.Apartment : '-'}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Provincia:  "
                            secondary={order.CountrySubdivision}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Ciudad:  "
                            secondary={order.City}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Localidad:  "
                            secondary={order.Locality}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Código Postal:  "
                            secondary={order.PostalCode}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <Divider />
                        <ListItemText
                            primary="Peso del paquete (en gramos):  "
                            secondary={order.ParcelWeightInGrams ? order.ParcelWeightInGrams : 0}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        {order.Error
                            ? <>
                                <Divider />
                                {order.Error.map((error) => {
                                    return (
                                        <ListItemText
                                            key={error.message}
                                            primary={`ERROR: ${error.message}`}
                                            className={styles.errorMessage}
                                        />
                                    )
                                })}
                            </>
                            : null}
                        {order.SaveError && saveErrors
                            ? <>
                                <Divider />
                                {order.SaveError.map((error) => {
                                    return (
                                        <ListItemText
                                            key={error.message}
                                            primary={`ERROR: ${error.message}`}
                                            className={styles.errorMessage}
                                        />
                                    )
                                })}
                            </>
                            : null}
                    </List>
                </DialogContent>
            </Dialog>
            <Dialog
                open={lockerOpen}
                onClose={() => setLockerOpen(false)}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                className={styles.dialog}
                scroll={'paper'}
                maxWidth={'sm'}
                fullWidth
            >
                <DialogTitle id="scroll-dialog-title">
                    Envío mediante SmartLocker
                    <IconButton
                        aria-label="close"
                        className={styles.closeBtn}
                        onClick={() => setLockerOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers={true}>
                    <List
                        className={styles.list}
                        id="scroll-dialog-description"
                    >
                        {order.DepositCode !== null && order.DepositCode !== undefined ? (
                            <ListItemText
                                primary="Código de depósito:  "
                                secondary={order.DepositCode}
                                primaryTypographyProps={{ display: 'inline' }}
                                secondaryTypographyProps={{ display: 'inline' }}
                            />
                        ) : null}
                        <ListItemText
                            primary="Alias:  "
                            secondary={order.Alias ? order.Alias : '-'}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Nombre:  "
                            secondary={order.ClientName}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Mail:  "
                            secondary={order.ClientMail}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Teléfono:  "
                            secondary={order.ClientPhone}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <Divider />
                        <ListItemText
                            primary="Peso del paquete (en gramos):  "
                            secondary={order.ParcelWeightInGrams ? order.ParcelWeightInGrams : 0}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Tamaño del paquete (en mm):  "
                            secondary={
                                (order.ParcelHeightInMm ? parseInt(order.ParcelHeightInMm.toString()) || 0 : 0) +
                                ' x ' +
                                (order.ParcelLengthInMm ? parseInt(order.ParcelLengthInMm.toString()) || 0 : 0) +
                                ' x ' +
                                (order.ParcelWidthInMm ? parseInt(order.ParcelWidthInMm.toString()) || 0 : 0)
                            }
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <ListItemText
                            primary="Tamaño de puerta para el SmartLocker:  "
                            secondary={props.DoorSizeId}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        <Divider />
                        <ListItemText
                            primary="SmartLocker:  "
                            secondary={'[ ID ' + order.LockerId + ' ]  ' + (!lockerInfo ? 'Locker no habilitado' : lockerInfo.name)}
                            primaryTypographyProps={{ display: 'inline' }}
                            secondaryTypographyProps={{ display: 'inline' }}
                        />
                        {!lockerInfo ? null : <>
                            <ListItemText
                                primary="Dirección:  "
                                secondary={lockerInfo.locationAddress}
                                primaryTypographyProps={{ display: 'inline' }}
                                secondaryTypographyProps={{ display: 'inline' }}
                            />
                            <ListItemText
                                primary="Detalles:  "
                                secondary={lockerInfo.locationDetails}
                                primaryTypographyProps={{ display: 'inline' }}
                                secondaryTypographyProps={{ display: 'inline' }}
                            />
                            <ListItemText
                                primary="Ciudad:  "
                                secondary={lockerInfo.city}
                                primaryTypographyProps={{ display: 'inline' }}
                                secondaryTypographyProps={{ display: 'inline' }}
                            />
                        </>}
                        { !orderCustomSecurity ? null : <>
                            <Divider />
                            <ListItemText
                                primary={
                                <Typography display="inline" style={{ fontWeight: 'bold' }}>
                                    Seguridad extra para el retiro:
                                </Typography>
                              }
                            />
                            {String(order.RequestSignature!).toLowerCase() !== 'true' || !order.RequestSignature ? null :
                                <ListItemText
                                    primary="Solicitar firma:  "
                                    secondary='Sí'
                                    primaryTypographyProps={{ display: 'inline' }}
                                    secondaryTypographyProps={{ display: 'inline' }}
                                />
                            }
                            {String(order.RequestToken!).toLowerCase() !== 'true' || !order.RequestToken ? null :
                                <ListItemText
                                    primary="Solicitar token:  "
                                    secondary='Sí'
                                    primaryTypographyProps={{ display: 'inline' }}
                                    secondaryTypographyProps={{ display: 'inline' }}
                                />
                            }
                            {order.CustomCode || order.CustomCodeType ?
                                <ListItemText
                                    primary="Código de seguridad:  "
                                    secondary={
                                        order.CustomCodeType && String(order.CustomCodeType).toLowerCase() === 'dni' ? `${order.CustomCode} (DNI)` 
                                        : order.CustomCodeType && String(order.CustomCodeType).toLowerCase() === 'alphanumeric' ? `${order.CustomCode} (Alfanumérico)`
                                        : order.CustomCode && !order.CustomCodeType ? `${order.CustomCode} (undefined)`
                                        : null
                                    }
                                    primaryTypographyProps={{ display: 'inline' }}
                                    secondaryTypographyProps={{ display: 'inline' }}
                                />
                            : null }
                        </>}
                        {order.Error
                            ? <>
                                <Divider />
                                {order.Error.map((Error) => {
                                    return (
                                        <ListItemText
                                            key={Error.message}
                                            primary={`ERROR: ${Error.message}`}
                                            className={styles.errorMessage}
                                        />
                                    )
                                })}
                            </>
                            : null}
                        {order.SaveError && saveErrors
                            ? <>
                                <Divider />
                                {order.SaveError.map((error) => {
                                    return (
                                        <ListItemText
                                            key={error.message}
                                            primary={`ERROR: ${error.message}`}
                                            className={styles.errorMessage}
                                        />
                                    )
                                })}
                            </>
                            : null}

                    </List>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default ImportSheetTable
